import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const BlogCard = ({ id, title, excerpt, imageUrl, date, readTime }) => {
  return (
    <div className="h-100">
      <Link to={`/blog/${id}`} style={{ textDecoration: 'none' }}>
        <Card className="blog-card border-0 h-100">
          <div
            style={{
              height: '220px',
              background: `url(${imageUrl}) center/cover no-repeat`
            }}
          />
          <Card.Body className="p-4 d-flex flex-column">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <small className="text-muted">{date}</small>
              <small className="text-muted">{readTime} read</small>
            </div>
            <h4 className="h5 mb-3" style={{ color: 'var(--primary-green)' }}>
              {title}
            </h4>
            <p className="text-muted mb-0 flex-grow-1" style={{ fontSize: '0.9rem' }}>
              {excerpt}
            </p>
            <div className="mt-3">
              <span style={{
                color: 'var(--muted-gold)',
                fontSize: '0.9rem',
                fontWeight: '500'
              }}>
                Read More →
              </span>
            </div>
          </Card.Body>
        </Card>
      </Link>
    </div>
  );
};

export default BlogCard;